import { KeyboardEvent, MutableRefObject, SyntheticEvent } from 'react';

import type { ImageSrcParams } from '@picsart/rc/types';

import { ActionTypes } from 'constants/enums';
import { IStrapiComponent } from 'types/global';

export type UseWindowSize = () => { width: number; height: number };

export type ImageConvertParamsProps = {
  src: string;
  width: number;
  height: number;
  type?: string;
  action?: ActionTypes.crop | ActionTypes.fixed | ActionTypes.min;
};

export type UseImageConvertParams = (props: ImageConvertParamsProps) => ImageSrcParams;
export type HandleToggle = (state?: boolean) => void;

export type useScrollProps = {
  isX?: number;
  isY?: number;
};

export type useScrollData = {
  isXScrolledThen?: boolean;
  isYScrolledThen?: boolean;
  scrollX: number;
  scrollY: number;
};

export type UseObservable = (index?: number) => (node?: Element | null) => void;

export type useReplaceTitleProps = {
  toBeReplaced: string;
  replaceValue?: string;
  unique?: boolean;
};

export type UseKeyPressHandlerArg = (
  cb: (...values: any[]) => void,
  keyNames: KeyBoardKeys | KeyBoardKeys[],
) => UseKeyPressHandler;

export type UseKeyPressHandler = (event: KeyboardEvent<HTMLElement>, ...values: any[]) => void;

export enum KeyBoardKeys {
  Enter = 'Enter',
}

export type PageLocationParameters = {
  slug: string | undefined;
  slugWithQueryParams: string;
  queryParams: string;
  languageParam: string;
  fullPath: string;
};

export enum DeviceType {
  isAndroid = 'Android',
  isDesktop = 'Desktop',
  isTablet = 'Tablet',
  isMobile = 'Mobile',
  isIOS = 'IOS',
}

export type useQtWidgetProps = IStrapiComponent;

export type UseHandleEditClick = (
  isMobile: boolean,
  isTargetBlank?: boolean,
  /** pass the event if not in mobile */
) => (imageId: number, event?: SyntheticEvent, itemType?: string) => void;

export type UseCopyToClipboard = () => [boolean, (text: string) => void];

export type UseTemplateLoaderArgs = {
  initialUrl: string;
  objectId: number;
};

export type UseScrollToType = {
  x?: number;
  y?: number;
  behavior?: ScrollBehavior;
};

export type UseElementInViewProps = {
  elementRef: MutableRefObject<HTMLDivElement>;
  bottom?: number;
};
